<template>
   <div class="NewsDetails">
    <banner  />
    <div class="NewsDetails-product">
      <div class="NewsDetails-product-content">
        <img :src="newsIdList.imgurl" alt />
        <p class="product-title">{{newsIdList.title}}</p>
        <p class="product-time">{{newsIdList.CreateTime}}</p>
        <p class="product-content">{{newsIdList.Content}}</p>
        <div v-for="item in newsIdList.cimgurl" :key="item" class="cimg">
          <img  :src="item"  alt="">
        </div>
          <p class="product-content">{{newsIdList.m1}}</p>
         <div v-for="ite in newsIdList.c2imgurl" :key="ite" class="cimg">
          <img  :src="ite"  alt="">
        </div>
          <p class="product-content">{{newsIdList.m2}}</p>
          <img :src="newsIdList.c3imgurl" alt="" class="cimg">
          <p class="product-content">{{newsIdList.m3}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from '../components/Banner'
export default {
    data(){
        return{
            nid: 0,
            newsIdList: {}
        }
    },
    created() {
        this.nid = this.$route.params.id;
        this.newsIdList=this.$route.params.news
    },
    components:{
      Banner
    }
}
</script>
<style lang="scss" scoped>
.NewsDetails {
  width: 100%;
  height: 100%;
  //overflow: hidden;
  background-color: #14679f;
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    border: 1px solid red;
    &-content {
      width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 0;
      img {
        width: 100%;
        //height: 500px;
      }
      .product-title {
        font-size: 25px;
        color: #e13834;
        padding: 20px 0;
      }
      .product-content {
        font-size: 17px;
        font-weight: bolder;
        padding: 20px 0;
        text-indent: 35px;
      }
      .cimg{
        width: 70%;
        margin: 0 auto;
      }
    }
  }
}
</style>